import type { MarkRouteTypesReviewedInPlan } from "./types";

export const markRouteTypesReviewedInPlan: MarkRouteTypesReviewedInPlan = ({
  plan,
  routeTypeIds,
}) => {
  if (routeTypeIds.length === 0) return plan;
  const targetIds = new Set(routeTypeIds);

  let didFlip = false;
  const routeGroups = plan.routeGroups.map((group) => {
    if (
      !targetIds.has(group.route_type_id) ||
      group.cableTypeStatus === "confident"
    ) {
      return group;
    }
    didFlip = true;
    return { ...group, cableTypeStatus: "confident" as const };
  });

  if (!didFlip) return plan;
  return { ...plan, routeGroups };
};
